import React from 'react';
import { useDeliveryDetail } from '../context/DeliveryDetailContext';
export default function CheckProgressWidget() {
  const { answered, total, issues, delivery, readOnly } = useDeliveryDetail();
  const percentage = total ? Math.round(answered / total * 100) : 0;
  return <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <h2 className="font-bold text-slate-900">Check Progress</h2>
    <p className="mt-3 text-sm text-slate-600">{answered} of {total} questions answered</p>
    <div className="my-3 h-2 overflow-hidden rounded-full bg-slate-100"><div className="h-full bg-indigo-600" style={{ width: `${percentage}%` }} /></div>
    <p className="text-sm text-red-600">{issues} issues recorded</p>
    <p className="mt-3 text-xs text-slate-500">{delivery.legacySubmissionId && !delivery.submittedAt ? 'Imported historical draft; original record preserved.' : readOnly ? `Submitted ${new Date(delivery.submittedAt).toLocaleString('en-GB')}` : 'Save a draft to continue later. Approve and submit when all questions have been answered.'}</p>
  </section>;
}
